<template>
  <div class="filter-bar__search" :class="{ 'filter-bar__search--clearable': modelValue }">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
    <input
      :value="modelValue"
      type="search"
      :aria-label="label || placeholder"
      :placeholder="placeholder"
      @input="$emit('update:modelValue', $event.target.value)"
      @keydown.esc="clear"
    >
    <button
      v-if="modelValue"
      type="button"
      class="filter-bar__search-clear"
      aria-label="Limpiar búsqueda"
      @click="clear"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>
</template>

<script>
// El buscador de los listados del panel. Era el mismo bloque —lupa SVG a mano,
// input— copiado en nueve vistas, con `type` y `aria-label` distintos en cada
// copia y sin forma de borrar lo tecleado salvo seleccionar y suprimir.
export default {
  name: 'SearchInput',
  props: {
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: 'Buscar…' },
    // Etiqueta accesible cuando el placeholder no alcanza para describir el campo
    label: { type: String, default: '' }
  },
  emits: ['update:modelValue'],
  methods: {
    clear () {
      this.$emit('update:modelValue', '')
      const input = this.$el.querySelector('input')
      if (input) input.focus()
    }
  }
}
</script>
